import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { rulesApi } from '../services/api';
import RuleCard from '../components/RuleCard';
import SearchBox from '../components/SearchBox';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Loading from '../components/Loading';
import SEO from '../components/SEO';
import './Search.css';

function Search() {
  const [searchParams] = useSearchParams();
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const searchTerm = searchParams.get('q');

  const performSearch = useCallback(async (term) => {
    try {
      setLoading(true);
      const response = await rulesApi.search(term);
      setRules(response.data.data || []);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.message || 'Search failed');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (searchTerm) {
      performSearch(searchTerm);
    } else {
      setLoading(false);
    }
  }, [searchTerm, performSearch]);

  const pageTitle = searchTerm ? `Search: ${searchTerm}` : 'Search Rules';
  const pageDescription = searchTerm
    ? `Guy Rules matching "${searchTerm}". Browse etiquette and humor for guys.`
    : 'Search Guy Rules by keyword.';

  return (
    <>
      <SEO
        title={pageTitle}
        description={pageDescription}
        canonicalPath={searchTerm ? `/search?q=${encodeURIComponent(searchTerm)}` : '/search'}
      />
      <Header />
      <div className="container">
        <div className="search-page">
          <h1>Search Rules</h1>
          <SearchBox />

          {loading ? (
            <Loading />
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : (
            <>
              {searchTerm && rules.length > 0 && (
                <p className="search-results-header">Search results for: <strong>{searchTerm}</strong></p>
              )}
              <div className="search-results-grid">
                {rules.length === 0 ? (
                  <p className="search-results-empty">No search results</p>
                ) : (
                  rules.map((rule) => (
                    <RuleCard key={rule.id || rule.gr_id} rule={rule} />
                  ))
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Search;
